export const playerModalGetOpen = s => s.playerModal.get('open');
export const playerModalGetLink = s => s.playerModal.get('link');
export const playerModalGetPoster = s => s.playerModal.get('poster');
